import ChatImage from './ChatImage';

export default ChatImage;
